import Swiper, { Navigation, Pagination } from 'swiper'

const sharedConfig = {
  slidesPerView: 'auto',
  uniqueNavElements: true,
  watchOverflow: true,
  observer: true,
  observeParents: true,
  spaceBetween: 20,
  breakpoints: {
    768: {
      spaceBetween: 40,
    },
    1440: {
      spaceBetween: 60,
    },
  },
  modules: [Navigation, Pagination],
}
const careerCarouselConfig = {
  ...sharedConfig,
  slidesPerGroup: 1,
  loop: false,
  slideToClickedSlide: true,
  breakpoints: {
    768: {
      spaceBetween: 40,
      slidesPerGroup: 2,
    },
    1440: {
      slidesPerGroup: 3,
      spaceBetween: 60,
    },
  },
}
const imageCarouselConfig = {
  ...sharedConfig,
  slidesPerGroup: 1,
  slideToClickedSlide: true,
  loop: false,
}

// Function to return the appropriate carousel config
function getConfig(element) {
  let newConfig
  switch (element.dataset.carouseltype) {
    case 'values-carousel':
      newConfig = Object.assign({}, imageCarouselConfig)
      break
    case 'interview-carousel':
      newConfig = Object.assign({}, imageCarouselConfig)
      break
    default:
      newConfig = Object.assign({}, careerCarouselConfig)
  }
  return newConfig
}

function initSwiperCarousels() {
  // Query for all the swiper carousels
  let swiperCarousels = document.querySelectorAll('.swiper')
  if (swiperCarousels.length > 0) {
    for (let x = 0, max = swiperCarousels.length; x < max; x++) {
      let thisConfig = getConfig(swiperCarousels[x])
      let carouselPagination =
        swiperCarousels[x].querySelector('.swiper-pagination')
      let carouselControlPrev = swiperCarousels[x].querySelector(
        '.swiper-button-prev'
      )
      let carouselControlNext = swiperCarousels[x].querySelector(
        '.swiper-button-next'
      )

      if (carouselPagination) {
        thisConfig.pagination = {
          el: carouselPagination,
        }
      }

      if (carouselControlPrev && carouselControlNext) {
        thisConfig.navigation = {
          prevEl: carouselControlPrev,
          nextEl: carouselControlNext,
        }
      }

      if (
        swiperCarousels[x].querySelectorAll('.swiper-slide').length >
        thisConfig.slidesPerGroup
      ) {
        let swiperCarousel = new Swiper(swiperCarousels[x], thisConfig)
      } else if (swiperCarousels[x].dataset.carouseltype === 'card-carousel') {
        let swiperCarousel = new Swiper(swiperCarousels[x], thisConfig)
      }
    }
  }
}

export { initSwiperCarousels }
